import { render, staticRenderFns } from "./gestionCodigosLista.vue?vue&type=template&id=29fdcb5c&scoped=true"
import script from "./gestionCodigosLista.vue?vue&type=script&lang=js"
export * from "./gestionCodigosLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fdcb5c",
  null
  
)

export default component.exports